var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconClose = function SvgIconClose(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52318 15.123L4.48856 15.1628C4.42095 15.2596 4.43231 15.3932 4.52318 15.4784C4.62006 15.5753 4.7752 15.5753 4.87855 15.4784L10.0211 10.3774L15.1208 15.4776C15.2278 15.5779 15.3819 15.5799 15.4779 15.4776C15.5809 15.381 15.5809 15.2204 15.4771 15.123L10.3765 9.97252L15.4779 4.87068C15.581 4.77395 15.581 4.62003 15.4771 4.51603C15.3802 4.41913 15.225 4.41913 15.1217 4.51603L9.97171 9.61707L4.87938 4.51682C4.7752 4.41913 4.62006 4.41913 4.52318 4.51603C4.4192 4.62003 4.4192 4.77395 4.52318 4.87146L9.6237 10.0219L4.52318 15.123Z",
    fill: "white"
  }))));
};
export default SvgIconClose;